import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { CalculatorCreditor } from '../components';
import { selectSetting, selectSettingNumeric } from '../../../features/settings/ducks';
import { settingKeys } from '../../../common/enums';



const mapStateToProps = state => ({
  interestRange: selectSetting(state, settingKeys.INTEREST_RANGE),
  calculatorAmountMin: selectSettingNumeric(state, settingKeys.CREDITOR_ONBOARDING_CALCULATOR_MIN),
  calculatorAmountMax: selectSettingNumeric(state, settingKeys.CREDITOR_ONBOARDING_CALCULATOR_MAX),
  calculatorAmountStep: selectSettingNumeric(
    state,
    settingKeys.CREDITOR_ONBOARDING_CALCULATOR_STEP
  ),
  defaultAmount: selectSettingNumeric(state, settingKeys.CREDITOR_CALCULATOR_DEFAULT_AMOUNT),
  defaultMonths: selectSettingNumeric(state, settingKeys.CREDITOR_CALCULATOR_DEFAULT_MONTHS),
  minMonths: selectSettingNumeric(state, settingKeys.LOAN_MIN_MONTHS),
  maxMonths: selectSettingNumeric(state, settingKeys.LOAN_MAX_MONTHS),
});

const mapDispatchToProps = dispatch => ({
  goToSignUp: calculator =>
    dispatch(push({ pathname: 'onboarding/creditor/sign-up', state: { calculator } })),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class CalculatorCreditorContainer extends Component {
  static propTypes = {
    interestRange: PropTypes.array.isRequired,
    calculatorAmountMin: PropTypes.number.isRequired,
    calculatorAmountMax: PropTypes.number.isRequired,
    calculatorAmountStep: PropTypes.number.isRequired,
    defaultAmount: PropTypes.number.isRequired,
    defaultMonths: PropTypes.number.isRequired,
    goToSignUp: PropTypes.func.isRequired,
  };

  render() {
    const {
      interestRange,
      calculatorAmountMin,
      calculatorAmountMax,
      calculatorAmountStep,
      defaultAmount,
      defaultMonths,
      goToSignUp,
      minMonths,
      maxMonths,
      location
    } = this.props;

    //const { calculatorMonthsMin, calculatorMonthsMax, calculatorMonthsStep } = config;
    const calculatorMonthsMin = minMonths
    const calculatorMonthsMax = maxMonths
    const calculatorMonthsStep = 1
    return (
      <CalculatorCreditor
        interestRange={interestRange}
        calculatorAmountMin={calculatorAmountMin}
        calculatorAmountMax={calculatorAmountMax}
        calculatorAmountStep={calculatorAmountStep}
        calculatorMonthsMin={calculatorMonthsMin}
        calculatorMonthsMax={calculatorMonthsMax}
        calculatorMonthsStep={calculatorMonthsStep}
        defaultAmount={defaultAmount}
        defaultMonths={defaultMonths}
        goToSignUp={goToSignUp}
        location={location}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/calculator/containers/CalculatorCreditorContainer.js